import {
  Div,
  DownloadCloudIcon,
  ErrorToast,
  Icon,
  ImagePreview,
  SuccessToast,
  api,
  reportError,
} from '@vgrubs/components';
import { LocationEntity } from 'components/src/types/location.types';
import Compressor from 'compressorjs';
import { saveAs } from 'file-saver';
import { Dispatch, SetStateAction, useRef } from 'react';
import styled from 'styled-components';

const AdminInputStyled = styled.div`
  input {
    visibility: hidden;
    height: 0;
    width: 0;
  }
`;

export const ImageInput = ({
  data,
  children,
  setData,
  setLoading,
}: {
  data: LocationEntity | null;
  children: React.ReactNode;
  setData: Dispatch<SetStateAction<LocationEntity | null>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
}) => {
  const inputFileRef = useRef<HTMLInputElement>(null);

  const onBtnClick = () => {
    inputFileRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    const file = files?.[0];
    const maxSize = 2097152;

    if (file) {
      new Compressor(file, {
        quality: 0.8,
        maxWidth: 2500,
        maxHeight: 1500,
        convertSize: 2097152,
        success: (compressedResult) => {
          if (compressedResult.size > maxSize) {
            return ErrorToast('Image file too big');
          } else {
            handleAddImage(compressedResult);
          }
        },
      });
    }
  };

  async function handleAddImage(img: string | Blob | File | null) {
    const imageData = {
      type: 'voidCheck',
    };

    const formData = new FormData();
    formData.append('image', img as Blob);
    formData.append('imageData', JSON.stringify(imageData));

    try {
      setLoading(true);

      // onAddBrandSuccess(brand.name);
      const res = await api.post(`/v1/locations/${data!.id}/image`, formData, {
        headers: { 'content-type': 'multipart/form-data' },
      });

      setData((prev) => {
        if (!prev) return null;
        return {
          ...prev,
          images: [{ url: res.data.data, type: 'voidCheck' }, ...prev.images],
        } as LocationEntity;
      });
      SuccessToast(res.data.message);

      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <AdminInputStyled onClick={onBtnClick}>
      {children}
      <input ref={inputFileRef} type="file" onChange={handleChange} />
    </AdminInputStyled>
  );
};

export const ImageWithDownload = ({
  src,
  lightbox,
}: {
  src: string;
  /** Open full screen in the chat's lightbox, see ImagePreview. */
  lightbox?: boolean;
}) => {
  return (
    <Div
      $flex
      $box
      $p="16px"
      $width="100%"
      $widthSM="100%"
      style={{ aspectRatio: '1/1' }}
      $relative
    >
      <ImagePreview
        image={src}
        style={{ objectFit: 'contain' }}
        lightbox={lightbox}
      />
      <Icon
        style={{ position: 'absolute', top: '20px', right: '20px' }}
        $pointer
        onClick={() => saveAs(src)}
      >
        <DownloadCloudIcon />
      </Icon>
    </Div>
  );
};
